module.exports = __webpack_public_path__ + "1605cd17db78e453d73214bd80756b4f.svg";